import { uiText, getUiLocale } from '../i18n/uiText';

// Only server-labelled system copy is translated. A comment, an audit name or
// a colleague's written explanation must remain exactly as it was authored.
export function notificationText(item, locale = getUiLocale()) {
  const original = item?.text || item?.description || '';
  const copy = item?.text_i18n;
  if (!copy || typeof copy.template !== 'string' || !copy.values || typeof copy.values !== 'object' || Array.isArray(copy.values)) return original;
  if (Object.values(copy.values).some(value => value != null && !['string', 'number', 'boolean'].includes(typeof value))) return original;
  return uiText(copy.template, copy.values, locale);
}
